import { LayaGL } from "../layagl/LayaGL";
import { Color } from "../maths/Color";
import { RenderTargetFormat } from "../RenderEngine/RenderEnum/RenderTargetFormat";
import { RenderTexture } from "../resource/RenderTexture";
import { Browser } from "./Browser";
var _gid = 1;
const _pi = 180 / Math.PI;
const _pi2 = Math.PI / 180;
export class Utils {
    static toRadian(angle) {
        return angle * _pi2;
    }
    static toAngle(radian) {
        return radian * _pi;
    }
    static toHexColor(color) {
        return Color.hexToString(color);
    }
    static fromStringColor(value) {
        return Color.stringToHex(value);
    }
    static getGID(target, method) {
        let cid = target ? (target[objUidKey] || (target[objUidKey] = _gid++)) : 0;
        let mid = method ? (typeof (method) === "string" ? method : (method[objUidKey] || (method[objUidKey] = _gid++))) : 0;
        return cid + "_" + mid;
    }
    static copyArray(source, array) {
        source || (source = []);
        if (!array)
            return source;
        source.length = array.length;
        var len = array.length;
        for (let i = 0; i < len; i++) {
            source[i] = array[i];
        }
        return source;
    }
    static parseInt(str, radix = 0) {
        var result = parseInt(str, radix);
        if (isNaN(result))
            return 0;
        return result;
    }
    static getBaseName(path, withoutExtension) {
        let i = path.lastIndexOf("/");
        if (i != -1)
            path = path.substring(i + 1);
        i = path.indexOf("?");
        if (i != -1)
            path = path.substring(0, i);
        if (withoutExtension) {
            i = path.lastIndexOf(".");
            if (i != -1)
                path = path.substring(0, i);
        }
        return path;
    }
    static getFileExtension(path) {
        let i = path.lastIndexOf(".");
        if (i != -1) {
            let ext = path.substring(i + 1).toLowerCase();
            let j = ext.indexOf("?");
            if (j != -1)
                ext = ext.substring(0, j);
            if (ext === "ls") {
                let k = path.lastIndexOf(".", i - 1);
                if (k != -1) {
                    let ext2 = path.substring(k + 1, i + 1) + ext;
                    if (ext2 === "lanit.ls" || ext2 === "ltcb.ls")
                        return ext2;
                }
            }
            return ext;
        }
        else
            return "";
    }
    static replaceFileExtension(path, newExt, excludeDot) {
        if (!path)
            return path;
        let i = path.lastIndexOf(".");
        if (newExt.length > 0 && !excludeDot)
            newExt = "." + newExt;
        if (i != -1) {
            let j = path.indexOf("?", i);
            if (j != -1)
                return path.substring(0, i) + newExt + path.substring(j);
            else
                return path.substring(0, i) + newExt;
        }
        else
            return path + newExt;
    }
    static isUUID(str) {
        return str && str.length >= 36 && str.charCodeAt(8) === 45 && str.charCodeAt(13) === 45;
    }
    static uint8ArrayToArrayBuffer(rendertexture) {
        let pixelArray;
        const width = rendertexture.width;
        const height = rendertexture.height;
        const pixelCount = width * height * 4;
        const colorFormat = (rendertexture instanceof RenderTexture) ? rendertexture.colorFormat : rendertexture.getColorFormat();
        switch (colorFormat) {
            case RenderTargetFormat.R8G8B8:
            case RenderTargetFormat.R8G8B8A8:
                pixelArray = new Uint8Array(pixelCount);
                break;
            case RenderTargetFormat.R16G16B16A16:
                pixelArray = new Float32Array(pixelCount);
                break;
            default:
                throw new Error("uint8ArrayToArrayBuffer is not supported for " + rendertexture.format.toString() + "format");
        }
        LayaGL.textureContext.readRenderTargetPixelData(rendertexture._renderTarget, 0, 0, width, height, pixelArray);
        if (colorFormat === RenderTargetFormat.R16G16B16A16) {
            const ori = pixelArray;
            const trans = new Uint8Array(pixelCount);
            for (let i = 0, n = ori.length; i < n; i++) {
                trans[i] = Math.min(Math.floor(ori[i] * 255), 255);
            }
            pixelArray = trans;
        }
        const pixels = pixelArray;
        const canvas = Browser.createElement("canvas");
        canvas.height = height;
        canvas.width = width;
        const ctx2d = canvas.getContext('2d');
        const imgdata = ctx2d.createImageData(width, height);
        imgdata.data.set(new Uint8ClampedArray(pixels));
        ctx2d.putImageData(imgdata, 0, 0);
        const base64String = canvas.toDataURL();
        canvas.remove();
        return base64String;
    }
    static uint8ArrayToArrayBufferAsync(rendertexture) {
        if (window.conch) {
            return Promise.resolve("not surpport");
        }
        let pixelArray;
        const width = rendertexture.width;
        const height = rendertexture.height;
        const pixelCount = width * height * 4;
        const colorFormat = (rendertexture instanceof RenderTexture) ? rendertexture.colorFormat : rendertexture.getColorFormat();
        switch (colorFormat) {
            case RenderTargetFormat.R8G8B8:
            case RenderTargetFormat.R8G8B8A8:
                pixelArray = new Uint8Array(pixelCount);
                break;
            case RenderTargetFormat.R16G16B16A16:
                pixelArray = new Float32Array(pixelCount);
                break;
            default:
                throw "this function is not surpprt " + rendertexture.format.toString() + "format Material";
        }
        return rendertexture.getDataAsync(0, 0, width, height, pixelArray).then(() => {
            if (colorFormat === RenderTargetFormat.R16G16B16A16) {
                const ori = pixelArray;
                const trans = new Uint8Array(pixelCount);
                for (let i = 0, n = ori.length; i < n; i++) {
                    trans[i] = Math.min(Math.floor(ori[i] * 255), 255);
                }
                pixelArray = trans;
            }
            const pixels = pixelArray;
            const canvas = Browser.createElement("canvas");
            canvas.height = height;
            canvas.width = width;
            const ctx2d = canvas.getContext('2d');
            const imgdata = ctx2d.createImageData(width, height);
            imgdata.data.set(new Uint8ClampedArray(pixels));
            ctx2d.putImageData(imgdata, 0, 0);
            const base64String = canvas.toDataURL();
            canvas.remove();
            return Promise.resolve(base64String);
        });
    }
    static parseTemplate(template, vars) {
        let pos1 = 0, pos2, pos3;
        let tag;
        let value;
        let result = "";
        while ((pos2 = template.indexOf("{", pos1)) != -1) {
            if (pos2 > 0 && template.charCodeAt(pos2 - 1) == 92) {
                result += template.substring(pos1, pos2 - 1);
                result += "{";
                pos1 = pos2 + 1;
                continue;
            }
            result += template.substring(pos1, pos2);
            pos1 = pos2;
            pos2 = template.indexOf("}", pos1);
            if (pos2 == -1)
                break;
            if (pos2 == pos1 + 1) {
                result += template.substring(pos1, pos1 + 2);
                pos1 = pos2 + 1;
                continue;
            }
            tag = template.substring(pos1 + 1, pos2);
            pos3 = tag.indexOf("=");
            if (pos3 != -1) {
                value = vars[tag.substring(0, pos3)];
                if (value == null)
                    result += tag.substring(pos3 + 1);
                else
                    result += value;
            }
            else {
                value = vars[tag];
                if (value != null)
                    result += value;
            }
            pos1 = pos2 + 1;
        }
        if (pos1 < template.length)
            result += template.substring(pos1);
        return result;
    }
    static sleep(timeout) {
        if (timeout < 1)
            return Promise.resolve();
        else
            return new Promise((resolve) => setTimeout(resolve, timeout));
    }
    static until(predicate, timeout) {
        if (predicate())
            return Promise.resolve();
        return new Promise((resolve) => {
            let start = performance.now();
            function timer() {
                if (predicate())
                    resolve();
                else if (timeout != null && performance.now() - start > timeout)
                    resolve();
                else
                    setTimeout(timer, 10);
            }
            setTimeout(timer, 10);
        });
    }
    static runTasks(datas, numParallelTasks, taskFunc, abortToken) {
        let limitFunc;
        if (typeof (numParallelTasks) !== "number") {
            limitFunc = numParallelTasks;
            numParallelTasks = 0;
        }
        let total = datas.length;
        if (numParallelTasks >= total) {
            return Promise.all(datas.map((value, index) => {
                if (abortToken && abortToken.aborted)
                    return Promise.reject("aborted");
                else
                    return taskFunc(value, index);
            }));
        }
        const results = new Array(total);
        const executing = [];
        let i = 0;
        function processNext() {
            if (i >= total || (abortToken === null || abortToken === void 0 ? void 0 : abortToken.aborted)) {
                return Promise.resolve();
            }
            const j = i++;
            const item = datas[j];
            const p = Promise.resolve().then(() => {
                if (abortToken === null || abortToken === void 0 ? void 0 : abortToken.aborted) {
                    return Promise.reject("aborted");
                }
                return taskFunc(item, j);
            }).then((result) => {
                results[j] = result;
                executing.splice(executing.indexOf(p), 1);
            });
            executing.push(p);
            if (limitFunc ? limitFunc(executing.length) : executing.length >= numParallelTasks) {
                return Promise.race(executing).then(processNext);
            }
            else {
                return processNext();
            }
        }
        const initialPromises = [];
        const initialCount = Math.min(numParallelTasks, total);
        for (let i = 0; i < initialCount; i++) {
            initialPromises.push(processNext());
        }
        return Promise.all(initialPromises)
            .then(() => {
            if (executing.length > 0)
                return Promise.all(executing);
            else
                return null;
        }).then(() => results);
    }
    static runAllTasks(datas, numParallelTasks, taskFunc, abortToken) {
        let limitFunc;
        if (typeof (numParallelTasks) !== "number") {
            limitFunc = numParallelTasks;
            numParallelTasks = 0;
        }
        let total = datas.length;
        if (numParallelTasks >= total) {
            return Promise.allSettled(datas.map((value, index) => Promise.resolve().then(() => {
                if (abortToken && abortToken.aborted)
                    return Promise.reject("aborted");
                else
                    return taskFunc(value, index);
            })));
        }
        const results = new Array(total);
        const executing = [];
        let i = 0;
        function processNext() {
            if (i >= total || (abortToken === null || abortToken === void 0 ? void 0 : abortToken.aborted)) {
                return Promise.resolve();
            }
            const j = i++;
            const item = datas[j];
            const p = Promise.resolve().then(() => {
                if (abortToken && abortToken.aborted)
                    return Promise.reject("aborted");
                else
                    return taskFunc(item, j);
            }).then((result) => {
                results[j] = { status: "fulfilled", value: result };
                executing.splice(executing.indexOf(p), 1);
            }).catch((reason) => {
                results[j] = { status: "rejected", reason };
                executing.splice(executing.indexOf(p), 1);
            });
            executing.push(p);
            if (limitFunc ? limitFunc(executing.length) : executing.length >= numParallelTasks) {
                return Promise.race(executing).then(processNext);
            }
            else {
                return processNext();
            }
        }
        const initialPromises = [];
        const initialCount = Math.min(numParallelTasks, total);
        for (let i = 0; i < initialCount; i++) {
            initialPromises.push(processNext());
        }
        return Promise.allSettled(initialPromises)
            .then(() => {
            if (executing.length > 0)
                return Promise.allSettled(executing);
            else
                return null;
        }).then(() => results);
    }
    static compareVersion(ver1, ver2) {
        let v1 = ver1.split('.');
        let v2 = ver2.split('.');
        const len = Math.max(v1.length, v2.length);
        while (v1.length < len) {
            v1.push('0');
        }
        while (v2.length < len) {
            v2.push('0');
        }
        for (let i = 0; i < len; i++) {
            const num1 = parseInt(v1[i]);
            const num2 = parseInt(v2[i]);
            if (num1 > num2) {
                return 1;
            }
            else if (num1 < num2) {
                return -1;
            }
        }
        return 0;
    }
    static testPointInPolygon(x, y, areaPoints) {
        var nCross = 0;
        var p1x, p1y, p2x, p2y;
        var len;
        len = areaPoints.length;
        for (var i = 0; i < len; i += 2) {
            p1x = areaPoints[i];
            p1y = areaPoints[i + 1];
            p2x = areaPoints[(i + 2) % len];
            p2y = areaPoints[(i + 3) % len];
            if (p1y == p2y)
                continue;
            if (y < Math.min(p1y, p2y))
                continue;
            if (y >= Math.max(p1y, p2y))
                continue;
            var tx = (y - p1y) * (p2x - p1x) / (p2y - p1y) + p1x;
            if (tx > x)
                nCross++;
        }
        return (nCross % 2 == 1);
    }
}
const objUidKey = Symbol();
